import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import { Navigate } from 'react-router-dom';
import PortalLayout from './PortalLayout';
import StudioResources from '../admin/StudioResources';
import { useAuth } from '../../App';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Member-portal wrapper that renders Studio Resources inside the portal shell,
// gated by studio approval (admins bypass).
export default function ClientStudioResources() {
  const { user } = useAuth();
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const isAdmin = user?.role === 'admin' || user?.role === 'super_admin';

  useEffect(() => {
    axios.get(`${API_URL}/api/auth/me/studio-access-status`, { withCredentials: true })
      .then((r) => setStatus(r.data)).catch(() => setStatus(null)).finally(() => setLoading(false));
  }, []);

  const approved = status?.is_studio_approved || isAdmin;
  if (loading) return <PortalLayout active="studio"><div className="flex justify-center py-16"><Loader2 className="animate-spin text-[#1D4ED8]" size={28} /></div></PortalLayout>;
  if (!approved) return <Navigate to="/portal/studio" replace />;
  return <PortalLayout active="studio"><StudioResources embedded /></PortalLayout>;
}
